module.exports = __webpack_public_path__ + "img/2x.ee3eeda.jpg";